/**
 * A simple factory method to scale px values via screen density or other targets.
 * @param scale The scale to multiple 1 raw px by. Defaults to the screen density of the current device.
 */
export var makePx = function (scale) {
    if (scale === void 0) { scale = window.devicePixelRatio; }
    return function (val) { return scale * val; };
};
